import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DeliveredListInvoice, InvoiceDelivered, InvoiceDeliveredItem } from "../model/delivered.model";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime, take, takeUntil } from "rxjs/operators";
import { PrintPolicy, PrintPolicyPrintTimeEnum } from "src/app/frontoffice/prints/model/print-policy.model";
import * as moment from "moment";
import { DeliveredInvoiceTypeEnum } from "../model/delivered-status.enum";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { Subscription } from "rxjs";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";

@Component({
  selector: "delivered",
  templateUrl: "./delivered.component.html",
  styleUrls: ["./delivered.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveredComponent extends BaseListComponent {
  activeTabTitle: string;
  SaleMethodNatureEnum = SaleMethodNature;
  SaleMethodBranchList: any[] = [];
  PrintPoliciesList: any[] = [];
  invoiceDeliveredList: InvoiceDelivered[] = [];
  formattedTime: string;
  showKitchenGrid: boolean = true;
  showDriverGrid: boolean = false;
  showCustomerGrid: boolean = false;
  checkBoxValue: boolean = false;
  MaxCookingTime: number = 0;
  public __id: string;
  formGroup: FormGroup = new FormGroup({
    PrintPolicies: new FormControl(null),
    SaleMethodBranchIds: new FormControl(null),
    checkBoxValue: new FormControl(null),
  });
  DeliveredListInvoicePending: DeliveredListInvoice[] = [];
  DeliveredListInvoiceDriver: DeliveredListInvoice[] = [];
  DeliveredListInvoiceKitchen: DeliveredListInvoice[] = [];
  data: any;
  public invoiceByBarCode: DeliveredListInvoice[] = [];
  public deliveredBarcodeName: string;
  private intervalId: any;
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private notification: NotificationService,
    _id: FormContainerModel
  ) {
    super();
    this.__id = _id.metadata.id;
    this.formGroup.addControl("barcodeInput" + this.__id, new FormControl(null));
  }

  async ngOnInit() {
    this.apiName = "";
    this.label = this.translate("ClientApp.Pages.PageMenu.Delivered");
    this.areaName = "";
    this.loadInvoices();
    this.loadSaleMethods();
    this.loadPrintPolicies();
    this.getInvoiceDelivered();
    super.ngOnInit();
    this.focusInput();
    this.cd.detectChanges();
    this.startTimer();
    this.init();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.intervalId) clearInterval(this.intervalId);
  }
  private init(): void {
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value.Key === "InvoiceChanges") {
        this.loadInvoices(false);
        this.cd.markForCheck();
        this.cd.detectChanges();
      }
    });
  }

  normalizeBarcodeInput(input: string): string {
    return input.replace(/إ/g, "B");
  }

  barCodeFinder(BarCode: any, tab: string) {
    let foundInvoicePending: DeliveredListInvoice;
    let foundInvoiceKitchen: DeliveredListInvoice;
    let foundInvoiceDriver: DeliveredListInvoice;

    try {
      const normalizedBarCode = this.normalizeBarcodeInput(BarCode);

      if (normalizedBarCode && normalizedBarCode.startsWith("B0")) {
        const numberingInDateCode = normalizedBarCode.slice(2); // حذف "B0"
        if (tab === "kitchen") {
          foundInvoicePending = this.DeliveredListInvoicePending?.find((inv) => inv.NumberingInDate === Number(numberingInDateCode));
        } else if (tab === "driver") {
          foundInvoiceDriver = this.DeliveredListInvoiceDriver?.find((inv) => inv.NumberingInDate === Number(numberingInDateCode));
        } else {
          foundInvoiceKitchen = this.DeliveredListInvoiceKitchen?.find((inv) => inv.NumberingInDate === Number(numberingInDateCode));
        }
        if (foundInvoicePending || foundInvoiceKitchen || foundInvoiceDriver) {
          // انجام عملیات‌های مرتبط با پیدا کردن فاکتور
          this.deliveredInvoice(foundInvoicePending || foundInvoiceKitchen || foundInvoiceDriver, false);
          this.formGroup.controls[`barcodeInput${this.__id}`].setValue("");
        } else {
          this.formGroup.controls[`barcodeInput${this.__id}`].setValue("");
        }
      }
    } catch (error) {
      throw new Error("The error message:" + error);
    }

    this.cd.markForCheck();
  }

  focus(id: string) {
    const input: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    if (input) {
      input.focus();
      input.select();
    }
  }
  public focusInput() {
    setTimeout(() => {
      this.focus(`barcodeInput${this.__id}`);
    }, 500);
  }

  changeTabAction(input: string) {
    if (input) {
      if (input == "driver") {
        this.showDriverGrid = true;
        this.showKitchenGrid = false;
        this.showCustomerGrid = false;
      } else if (input == "kitchen") {
        this.showKitchenGrid = true;
        this.showCustomerGrid = false;
        this.showDriverGrid = false;
      } else {
        this.showCustomerGrid = true;
        this.showKitchenGrid = false;
        this.showDriverGrid = false;
      }
    }
  }
  startTimer() {
    this.intervalId = setInterval(() => {
      this.getElapsedTime();
    }, 60000);
  }
  async getElapsedTime() {
    this.httpCommonService
      .getList("InvoiceDelivered/GetElpasedTime")
      .pipe(take(1))
      .subscribe((invoices: DeliveredListInvoice[]) => {
        invoices.forEach((x) => {
          if (this.DeliveredListInvoiceKitchen.some((i) => i.Id == x.Id))
            this.DeliveredListInvoiceKitchen.find((i) => i.Id == x.Id).DeliverStringTime = x.DeliverStringTime;
          if (this.DeliveredListInvoicePending.some((i) => i.Id == x.Id))
            this.DeliveredListInvoicePending.find((i) => i.Id == x.Id).FactorStringTime = x.FactorStringTime;
        });
        this.DeliveredListInvoicePending.forEach((invoice) => {
          invoice.Items.forEach((item) => {
            this.MaxCookingTime = item.CookingTime > this.MaxCookingTime ? item.CookingTime : this.MaxCookingTime;
          });
          if (Number(invoice.FactorStringTime) > this.MaxCookingTime && this.MaxCookingTime != 0) {
            invoice.HasExpired = true;
            this.MaxCookingTime = 0;
          }
        });
        this.DeliveredListInvoiceKitchen.forEach((invoice) => {
          invoice.Items.forEach((item) => {
            this.MaxCookingTime = item.CookingTime > this.MaxCookingTime ? item.CookingTime : this.MaxCookingTime;
          });
          if (Number(invoice.FactorStringTime) > this.MaxCookingTime && this.MaxCookingTime != 0) {
            invoice.HasExpired = true;
            this.MaxCookingTime = 0;
          }
        });
        this.cd.markForCheck();
      });
  }
  itemOnChange(invoice: DeliveredListInvoice) {
    if (!invoice.Items.some((c) => c.Checked == false)) {
      this.deliveredInvoice(invoice, false);
    }
  }
  loadInvoices(shouldBeSetValueCheckboxes = true) {
    this.httpCommonService
      .getList("InvoiceDelivered/DeliverdInvoicesList")
      .pipe(take(1))
      .subscribe((invoices: DeliveredListInvoice[]) => {
        this.data = invoices;
        this.DeliveredListInvoicePending = this.data
          .filter((e) => e.DeliveredInvoiceType == DeliveredInvoiceTypeEnum.Pending)
          .sort((a, b) => {
            if (b.NumberingInDate !== a.NumberingInDate) {
              return a.NumberingInDate - b.NumberingInDate;
            } else {
              return a.FactorStringTime - b.FactorStringTime;
            }
          });
        this.DeliveredListInvoiceKitchen = this.data
          .filter((e) => e.DeliveredInvoiceType == DeliveredInvoiceTypeEnum.DeliveredKitchen && e.SaleMethodNatureCode != SaleMethodNature.Delivery)
          .sort((a, b) => {
            if (b.NumberingInDate !== a.NumberingInDate) {
              return a.NumberingInDate - b.NumberingInDate;
            } else {
              return a.FactorStringTime - b.FactorStringTime;
            }
          });
        this.DeliveredListInvoiceDriver = this.data
          .filter((e) => e.DeliveredInvoiceType == DeliveredInvoiceTypeEnum.DeliveredKitchen && e.SaleMethodNatureCode == SaleMethodNature.Delivery)
          .sort((a, b) => {
            if (b.NumberingInDate !== a.NumberingInDate) {
              return a.NumberingInDate - b.NumberingInDate;
            } else {
              return a.FactorStringTime - b.FactorStringTime;
            }
          });
        this.DeliveredListInvoicePending.forEach((invoice) => {
          invoice.Items.forEach((item) => {
            if (shouldBeSetValueCheckboxes) this.setValue(`ItemChecked${item.ItemId} ${invoice.Id}`, item.Checked);
            this.MaxCookingTime = item.CookingTime > this.MaxCookingTime ? item.CookingTime : this.MaxCookingTime;
          });
          if (Number(invoice.FactorStringTime) > this.MaxCookingTime && this.MaxCookingTime != 0) {
            invoice.HasExpired = true;
            this.MaxCookingTime = 0;
          }
        });
        this.DeliveredListInvoiceKitchen.forEach((invoice) => {
          invoice.Items.forEach((item) => {
            if (shouldBeSetValueCheckboxes) this.setValue(`ItemChecked${item.ItemId} ${invoice.Id}`, item.Checked);
            this.MaxCookingTime = item.CookingTime > this.MaxCookingTime ? item.CookingTime : this.MaxCookingTime;
          });
          if (Number(invoice.FactorStringTime) > this.MaxCookingTime && this.MaxCookingTime != 0) {
            invoice.HasExpired = true;
            this.MaxCookingTime = 0;
          }
        });
        this.DeliveredListInvoiceDriver.forEach((invoice) => {
          invoice.Items.forEach((item) => {
            if (shouldBeSetValueCheckboxes) this.setValue(`ItemChecked${item.ItemId} ${invoice.Id}`, item.Checked);
            this.MaxCookingTime = item.CookingTime > this.MaxCookingTime ? item.CookingTime : this.MaxCookingTime;
          });
          if (Number(invoice.FactorStringTime) > this.MaxCookingTime && this.MaxCookingTime != 0) {
            invoice.HasExpired = true;
            this.MaxCookingTime = 0;
          }
        });
        this.cd.markForCheck();
      });
  }

  deliveredInvoice(invoice: DeliveredListInvoice, shouldBeSetValueCheckboxes = true, directDeliver: boolean = false) {
    try {
      const sendData: InvoiceDelivered = new InvoiceDelivered();
      sendData.InvoiceId = invoice.Id;
      sendData.SaleMethodNatureCode = invoice.SaleMethodNatureCode;
      const items = invoice.Items.filter((f) => f.Checked).map((x) => {
        const i = new InvoiceDeliveredItem();
        i.InvoiceItemId = x.ItemId;
        return i;
      });
      if (items.length == invoice.Items.length || items.length == 0 || (directDeliver && items.length != invoice.Items.length))
        sendData.DeliveredInvoiceType = DeliveredInvoiceTypeEnum.DeliveredKitchen;
      else if (items.length >= 0 && items.length < invoice.Items.length) sendData.DeliveredInvoiceType = DeliveredInvoiceTypeEnum.Pending;
      if (items.length && items.length < invoice.Items.length) sendData.InvoiceDeliveredItemList = items;
      this.httpCommonService
        .create(`InvoiceDelivered/DeliveredInvoice`, sendData)
        .pipe(take(1))
        .subscribe(() => {
          this.loadInvoices(shouldBeSetValueCheckboxes);
        });
    } catch (error) {}
    this.cd.markForCheck();
  }

  public SaleMethodChange(): void {
    if (this.formGroup.value?.SaleMethodBranchIds?.length && this.data.length) {
      this.DeliveredListInvoicePending = this.data
        .filter((invoice) => this.formGroup.value?.SaleMethodBranchIds.includes(invoice.SaleMethodBranchId))
        .sort((a, b) => {
          if (b.NumberingInDate !== a.NumberingInDate) {
            return a.NumberingInDate - b.NumberingInDate;
          } else {
            return a.FactorStringTime - b.FactorStringTime;
          }
        });
    } else if (!this.formGroup.value?.SaleMethodBranchIds?.length) {
      this.DeliveredListInvoicePending = this.data.sort((a, b) => {
        if (b.NumberingInDate !== a.NumberingInDate) {
          return a.NumberingInDate - b.NumberingInDate;
        } else {
          return a.FactorStringTime - b.FactorStringTime;
        }
      });
    }
    this.cd.markForCheck();
  }

  public PrintSettingChange(): void {
    if (this.formGroup.value?.PrintPolicies?.length) {
      const selectedPolicies = this.PrintPoliciesList.filter((x) => this.formGroup.value?.PrintPolicies.includes(x.Title));
      selectedPolicies.forEach((policy) => {
        const filteredData = this.data.filter((invoice) => {
          let filterIsPassed = true;
          if (policy.SaleMethodBranches.length) filterIsPassed = policy.SaleMethodBranches.includes(invoice.SaleMethodBranchId);
          if (filterIsPassed && policy.Salons.length) filterIsPassed = policy.Salons.includes(invoice.SalonId);
          if (filterIsPassed && (policy.Categories.length || policy.Items.length)) {
            const filteredItems = [];
            if (policy.Categories.length) {
              const items = invoice.Items.filter((item) => policy.Categories.includes(item.CategoryId));
              if (items.length) filteredItems.push(...items);
            }
            if (policy.Items.length) {
              const items = invoice.Items.filter((item) => policy.Items.includes(item.ItemId));
              if (items.length) filteredItems.push(...items);
            }
            if (filteredItems.length) invoice.Items = filteredItems;
            else filterIsPassed = false;
          }
          if (filterIsPassed && policy.IgnoredItems.length) invoice.Items.filter((x) => !policy.IgnoredItems.includes(x.ItemId));

          return filterIsPassed;
        });
        if (filteredData.length) {
          this.DeliveredListInvoicePending = [];
          this.DeliveredListInvoicePending.push(...filteredData);
        }
      });
    } else if (!this.formGroup.value?.SaleMethodBranchIds?.length) this.DeliveredListInvoicePending = this.data;
    this.cd.markForCheck();
  }

  public getInvoiceDelivered(): void {
    this.httpCommonService
      .getList("InvoiceDelivered/GetDeliveredInvoices")
      .pipe(take(1))
      .subscribe((data: InvoiceDelivered[]) => {
        if (data) {
          this.invoiceDeliveredList = data;
        }
      });
  }

  private loadPrintPolicies(): void {
    this.httpCommonService
      .getList("PrintPolicy/GetLookupPrintPolicies")
      .pipe(take(1))
      .subscribe((data: PrintPolicy[]) => {
        if (data) {
          const filteredPrinterList = data.filter((f) => {
            let x = f.PrintTimeCode === PrintPolicyPrintTimeEnum.PreparationPrint;
            return x;
          });
          this.PrintPoliciesList = filteredPrinterList;
        }
      });
  }

  private loadSaleMethods(): void {
    this.httpCommonService
      .getList("SaleMethodBranch/GetActiveSaleMethodBranchId")
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) this.SaleMethodBranchList = data;
        this.cd.markForCheck();
      });
  }

  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }

  isActiveTab(title: string) {
    return this.activeTabTitle === title;
  }
}
